import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ApiService from "../../../services/ApiService";
import { useAppContext } from "../../../context/AppContext";
import Swal from "sweetalert2";
import Toast from "../../../components/Toast";
import Sidebar from "../../../components/Sidebar";
import BackButton from '../../../components/BackButton';

const DumpSitePhotoReason: React.FC = () => {
  const navigate = useNavigate();
    const deliveryID = localStorage.getItem("delivery_id");
  const { purchaseOrder, delivery, setDelivery, photos, setPhotos } =
    useAppContext();
  const [oldTextReason, setOldTextReason] = useState<string>('');
  const [isReasonAdded, setIsReasonAdded] = useState<boolean>(false);
  const [buttonLoading, setButtonLoading] = useState<boolean>(false);
  const [reasonText, setReasonText] = useState<string | null>(null);
  const [toast, setToast] = useState<{
    message: string;
    type: "success" | "error";
  } | null>(null);
  useEffect(() => {
    let oldMaterialPhotoReason = [];
    if (photos && Array.isArray(photos)) {
      oldMaterialPhotoReason = photos.filter(
        (field: any) => field.photo_type === "dump_material" && field.delivery_id === delivery.id
      );
    }
    
    if (oldMaterialPhotoReason.length !== 0 && oldMaterialPhotoReason[0].file_url === null) {
      setOldTextReason(oldMaterialPhotoReason[0].reason)
      setIsReasonAdded(true);
    }
    if(oldTextReason && !reasonText) {
      setReasonText(oldTextReason);
    }
  }, [navigate, photos]);
  console.log('oldTextReason photos',oldTextReason); 
  const SubmitFileUploadTicket = async () => {
    setButtonLoading(true);
    
    const words = (reasonText ?? "")
      .trim()
      .split(/\s+/)
      .filter((word) => word.length > 0);
    if (!reasonText || words.length < 1) {
      Swal.fire({
        title: "Error",
        text: "Please write the valid reason at least 1 word",
        icon: "error",
        confirmButtonText: "Ok",
      });
      setButtonLoading(false);
      return;
    }

    // Use delivery from context or fallback to localStorage
    const deliveryID = localStorage.getItem("delivery_id");
    const currentDeliveryId = delivery?.id || deliveryID;
    if (!currentDeliveryId) {
      setToast({
        message: "Delivery ID not found. Please refresh the page.",
        type: "error",
      });
      setButtonLoading(false);
      return;
    }

    // Check if delivery is already completed
    if (delivery && delivery.status === 'completed') {
      setToast({
        message: "This delivery is already completed.",
        type: "error",
      });
      setButtonLoading(false);
      return;
    }

    const vendor_id = localStorage.getItem("vendor_id");
    let responseData = null;
    try {
      responseData = await ApiService.dumpPhotoReason({
        delivery_id: currentDeliveryId,
        reason: reasonText,
        vendor_id: vendor_id || null,
      });

      if (responseData && responseData.success) {
        setToast({
          message:
            responseData.message || "Updated Successfully, proceed to next step",
          type: "success",
        });
        setPhotos(responseData.data);
        setTimeout(() => {
           navigate("/digital-signature");
          // navigate("/proof-of-dumping");
        }, 500);
      } else {
        setToast({ message: responseData.message, type: "error" });
        setButtonLoading(false);
      }
    } catch (error: any) {
      setToast({
        message: "Something went wrong",
        type: "error",
      });
      setButtonLoading(false);
      console.error("Error Upload Reason:", error);
    }
 
  };
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <Sidebar />

          <div className="col-lg-9 col-12 content-area">
            <div className="row">
              <div className="col-12">
                <BackButton />
              </div>
              <div className="col-12">
                <div className="box">
                  <h5 className="mb-2 mt-3 text-center fw-semibold">
                    {" "}
                    Reason why a picture could not be captured.
                  </h5>
                </div>
              </div>
              <div className="col-md-12 m-auto">
                <div className="textarea-reason">
                  <label htmlFor="reason"> </label>
                  <textarea
                    name="reason"
                    value={reasonText ?? oldTextReason}
                    onChange={(e) => setReasonText(e.target.value)}
                    placeholder="Type valid reason..."
                    id="reason"
                    className="form-control"
                  > 
                  </textarea>
                </div>
              </div>
            </div>

            <div className="mt-3 d-flex row px-md-3 button_group m-auto flex-wrap align-items-center justify-content-center">
              <div className="px-md-auto px-0 col-lg-12 mt-3">
                <button
                  disabled={buttonLoading}
                  onClick={() => SubmitFileUploadTicket()}
                  className="btn-orange"
                >
                  {buttonLoading && (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  )}
                 {oldTextReason != '' ? 'Update' : 'Submit'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}
    </>
  );
};
export default DumpSitePhotoReason;
